import { CatalogPriceLineSubOptionZone } from "../models";
import { priceRequester as request } from "./requesters";

const catalogPriceLineSubOptionZoneService = {
  createCatalogPriceLineSubOptionZone: (data: CatalogPriceLineSubOptionZone) => request.post(`/catalog-price-line-sub-option-zones`, data),
};
export default catalogPriceLineSubOptionZoneService;
